import request from '@/utils/http';

// 司机费用分账 分页查询
const queryPage = data => {
    return request({
        url: `/api-antms/query/carrier/settlement/queryByPage`,
        method: 'post',
        data
    });
};
// 司机费用分账 总数查询
const queryCount = data => {
    return request({
        url: `/api-antms/query/carrier/settlement/queryCount`,
        method: 'post',
        data
    });
};
// 司机费用分账 分账填写
const divide = data => {
    return request({
        url: `/api-antms/billing/carrier/settlement/divide`,
        method: 'post',
        data
    });
};
// 司机费用分账 分账调整
const adjust = data => {
    return request({
        url: `/api-antms/billing/carrier/settlement/adjust`,
        method: 'post',
        data
    });
};
// 司机费用分账 批量支付查询
const driverBatchPayList = data => {
    return request({
        url: `/api-antms/query/carrier/settlement/driverBatchPayList`,
        method: 'post',
        data
    });
};
// 司机费用分账 批量支付查询
const queryMideaPayAccountList = data => {
    return request({
        url: `/api-antms/query/carrier/settlement/mideaPayAccount/list`,
        method: 'post',
        data
    });
};
// 司机费用分账 批量发起支付
const batchPay = data => {
    return request({
        url: `/api-antms/billing/carrier/settlement/batchPay`,
        method: 'post',
        data
    });
};

export {
    queryPage,
    queryCount,
    divide,
    adjust,
    driverBatchPayList,
    queryMideaPayAccountList,
    batchPay
};